import { v4 as uuid } from "uuid";

export function getVisitorId() {

    let id =
        localStorage.getItem("visitorId");

    if (!id) {

        id = uuid();

        localStorage.setItem(
            "visitorId",
            id
        );

    }

    return id;

}